export const CERTIFICATES_STATUSES = {
  all: {
    count: 0,
    label: "Все",
  },
  new: {
    count: 0,
    label: "Активные",
    certificateLabel: "Активен",
  },
  activated: {
    count: 0,
    label: "Использованные",
    certificateLabel: "Использован",
  },
};
